/**
 * Shared response handler for React Query API functions.
 *
 * Standardizes error handling for fetch responses across all query files.
 * Throws on non-OK responses with a descriptive error message.
 */

export async function handleResponse<T>(response: Response): Promise<T> {
	if (!response.ok) {
		if (response.status === 401) {
			throw new Error('UNAUTHORIZED')
		}
		const error = await response.text()
		throw new Error(error || `HTTP ${response.status}`)
	}
	return response.json()
}
